import React, { useEffect } from 'react';
import { SuspenseLoader } from '@bbkAdminComponents/loaders/suspense-loader';
import { AuthPanel } from '@bbkAdminComponents/log-in-flow/auth-panel';
import { LogInPaths } from '@bbkAdminComponents/log-in-flow/log-in-paths';
import { brightbackAuthSlice } from '@bbkAdminRedux/rtkq/brightback-auth.slice';

export const LogoutPage: React.FC = () => {
  const [signOut$] = brightbackAuthSlice.endpoints.signOut.useMutation();

  useEffect(() => {
    setTimeout(() => {
      signOut$({ redirect: LogInPaths.signIn });
    }, 1500);
  }, []);

  return (
    <AuthPanel>
      <div className="tw-text-center">
        <div className="tw-mb-4 tw-font-semibold">Signing you out...</div>
        <div>
          <SuspenseLoader message="" />
        </div>
      </div>
    </AuthPanel>
  );
};
